import { render, staticRenderFns } from "./user-stats.vue?vue&type=template&id=13f2d518&"
import script from "./user-stats.vue?vue&type=script&lang=js&"
export * from "./user-stats.vue?vue&type=script&lang=js&"
import style0 from "./user-stats.vue?vue&type=style&index=0&id=13f2d518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports